import type {
  ClearNameSanitizationRulesResponse,
  NameSanitizationRule,
  PreviewNameSanitizationResponse,
  RunNameCleaningResponse,
} from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { NameRulesGateway } from './name-rules.gateway';

/**
 * Real implementation over the shared api client: the single place that knows the
 * name-sanitization endpoints and request shapes. `api.get/post` unwrap the
 * `{ success, data }` envelope.
 */
export const httpNameRulesGateway: NameRulesGateway = {
  loadRules: () => api.get<NameSanitizationRule[]>('/name-sanitization/rules'),

  createRule: (payload) => api.post<NameSanitizationRule>('/name-sanitization/rules', payload),

  deleteRule: async (id) => {
    await api.delete(`/name-sanitization/rules/${id}`);
  },

  clearRules: (kind) =>
    api.delete<ClearNameSanitizationRulesResponse>(`/name-sanitization/rules?kind=${kind}`),

  preview: (name) =>
    api.post<PreviewNameSanitizationResponse>('/name-sanitization/preview', { name }),

  run: () => api.post<RunNameCleaningResponse>('/name-sanitization/run', {}),
};
